import { useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, formatApiError } from "@/lib/api";

export function NotifyModal({ slug, productName, trigger }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/notify", { email, slug });
      toast.success("You're on the list", {
        description: `We'll email you when the ${productName} drops.`,
      });
      setOpen(false);
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent
        data-testid={`notify-modal-${slug}`}
        className="border-white/15 bg-[#121418] text-slate-100 sm:max-w-md"
      >
        <DialogHeader>
          <div className="mono-label mb-2">Coming soon</div>
          <DialogTitle className="font-display text-2xl font-bold uppercase tracking-tight text-slate-100">
            {productName}
          </DialogTitle>
          <DialogDescription className="text-sm text-slate-400">
            This pack is in production. Leave your email and you'll be first to know when it launches.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-2 space-y-3">
          <Input
            data-testid={`notify-email-input-${slug}`}
            type="email"
            required
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border-white/15 bg-[#0A0B0D] text-slate-100 placeholder:text-slate-600"
          />
          <button
            data-testid={`notify-submit-${slug}`}
            type="submit"
            disabled={loading}
            className="w-full bg-[#FF5500] px-5 py-3 text-sm font-bold uppercase tracking-widest text-white transition-colors hover:bg-[#E04800] disabled:opacity-60"
          >
            {loading ? "Adding you…" : "Notify me at launch"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
